import { NotificationsService } from './notifications.service';
var NotificationsComponent = /** @class */ (function () {
    function NotificationsComponent(_notificationsService) {
        var _this = this;
        this._notificationsService = _notificationsService;
        this._notifications = [];
        this._notificationsService
            .getNotifications()
            .subscribe(function (notifications) { return _this._notifications = notifications; });
    }
    Object.defineProperty(NotificationsComponent.prototype, "notifications", {
        get: function () {
            return this._notifications.filter(function (notification) { return !notification.isClosed; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsComponent.prototype, "hasNotifications", {
        get: function () {
            return this.notifications && this.notifications.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsComponent.prototype, "hasUnreadNotifications", {
        get: function () {
            return this.notifications.some(function (notification) { return !notification.isRead; });
        },
        enumerable: true,
        configurable: true
    });
    NotificationsComponent.prototype.markAllNotificationsAsRead = function () {
        this._notificationsService.markAsRead(this.notifications);
    };
    NotificationsComponent.prototype.closeNotification = function (notification) {
        this._notificationsService.close(notification);
    };
    return NotificationsComponent;
}());
export { NotificationsComponent };
